import { computed, ref } from 'vue'
import { useNow } from '@/composables/game/time'
import type { Exchange } from '@/types/shared/exchange'
import { useConfig } from '@/composables/game/config'
import { backButtonCallback } from '@/router'

export const useExchange = () => {
  const { config } = useConfig()
  const { now } = useNow()

  const activeExchange = computed(() => {
    const exchange = config.value.game.exchange
    return exchange && exchange.from <= now.value && exchange.to >= now.value ? exchange : null
  })

  const countdownForExchangeEnd = computed(() => {
    if (!activeExchange.value) return 0

    const exchangeTo = activeExchange.value.to
    return Math.max(exchangeTo - now.value, 0)
  })

  const isCountdownCritical = computed(() => {
    const sixHours = 6 * 60 * 60
    return countdownForExchangeEnd.value > 0 && countdownForExchangeEnd.value < sixHours
  })

  return {
    activeExchange,
    countdownForExchangeEnd,
    isCountdownCritical,
  }
}

const selectedExchange = ref<Exchange | null>(null)

export const useExchangeOverlay = () => {
  const showExchangeOverlay = computed(() => !!selectedExchange.value)

  function hideExchangeOverlay() {
    backButtonCallback.value = null
    selectedExchange.value = null
  }

  function setSelectedExchange(exchange: Exchange) {
    backButtonCallback.value = hideExchangeOverlay
    selectedExchange.value = exchange
  }

  return {
    showExchangeOverlay,
    hideExchangeOverlay,
    setSelectedExchange,
    selectedExchange,
  }
}
